import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    bg: 'blackAlpha.100',
    borderRadius: 'md',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    overflow: 'hidden',
    borderWidth: '1px',
    borderColor: 'gray.300',
  },
  bodyStack: {
    p: 2,
    color: 'gray.700',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    fontFamily: 'body',
    fontSize: 'sm',
    color: 'gray.700',
  },
  footerFlex: {
    as: 'footer',
    bg: 'beta.700',
    boxShadow:
      '0px -2px 0px 0px rgba(0, 0, 0, 0.15), 0px -1px 0px 0px rgba(255, 255, 255, 0.25)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    px: '2',
    py: '1',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'white',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
  },
  footerSportNameIconSvg: {
    color: 'beta.100',
    fontSize: 'sm',
  },
  footerCompetitionNameText: {
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
      color: 'white',
    },
  },
  footerCountDown: {
    pt: '0',
    sx: {
      '&&': {
        color: 'white',
      },
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
        textTransform: 'uppercase',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
  },
  footerMatchLinkIcon: {
    color: 'beta.100',
    fontSize: 'sm',
  },
};
